import get from 'lodash/get';
import { PROFILE_FIELDS_TYPES } from '../../../../constants/formFields';
import { adaptRelationValue } from '../../../../utils/forms/EmergencyContact';

export const makeEmergencyInitialValue = (profile, relationList) => {
  const { email, relation, firstName, lastName, phoneNumber } =
    get(profile, 'primaryPatientProfile.emergencyContactAttributes') || {};
  return {
    [PROFILE_FIELDS_TYPES.EMAIL]: email,
    [PROFILE_FIELDS_TYPES.LAST_NAME]: lastName,
    [PROFILE_FIELDS_TYPES.FIRST_NAME]: firstName,
    [PROFILE_FIELDS_TYPES.PHONE_NUMBER]: phoneNumber,
    [PROFILE_FIELDS_TYPES.RELATION]: adaptRelationValue(relation, relationList),
  };
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/EmergencyContact/utils/makeEmergencyInitialValue.js